import StarRating from 'components/Shared/StarRating';
import { useTranslation } from 'react-i18next';
import { styles } from './styles';

interface AdvancedBannerProps {
  reviewCount: number;
  overallRating: number;
  ratingAverages: {
    valueRating: number;
    performanceRating: number;
    styleRating: number;
    comfortRating: number;
    fuelEconomyRating: number;
    maintenanceRating: number;
  };
  vehicleImage?: string;
  title?: string;
  onReviewsClick: () => void;
}

export default function AdvancedBanner(props: AdvancedBannerProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="banner-row">
      <div className="banner-container">
        <div className="banner-content">
          <div className="flex">
            <div className="vehicle-image">
              <img src={props.vehicleImage} />
            </div>
            <div className="title-wrapper">
              <h1>{props.title}</h1>
            </div>
          </div>
          <div className="flex">
            <div className="overall-rating-container" onClick={props.onReviewsClick}>
              <div className="flex">
                <StarRating value={props.overallRating} />{' '}
                <span className="overall-rating">{props.overallRating}</span>
              </div>
              <div className="review-count">{props.reviewCount} Reviews</div>
            </div>
            <div className="border" />
            <div className="review-breakdown-container">
              <div className="review-category">
                {t('seoSrp.advanced.overall')}{' '}
                <span className="breakdown-overall-rating">{props.overallRating}</span>
              </div>
              <div className="review-category">
                {t('seoSrp.advanced.performance')}{' '}
                <span className="breakdown-overall-rating">
                  {props.ratingAverages.performanceRating}
                </span>
              </div>
              <div className="review-category">
                {t('seoSrp.advanced.fuelEconomy')}{' '}
                <span className="breakdown-overall-rating">
                  {props.ratingAverages.fuelEconomyRating}
                </span>
              </div>
              <div className="review-category">
                {t('seoSrp.advanced.value')}{' '}
                <span className="breakdown-overall-rating">{props.ratingAverages.valueRating}</span>
              </div>
              <div className="review-category">
                {t('seoSrp.advanced.comfort')}{' '}
                <span className="breakdown-overall-rating">
                  {props.ratingAverages.comfortRating}
                </span>
              </div>
              <div className="review-category">
                {t('seoSrp.advanced.reliability')}{' '}
                <span className="breakdown-overall-rating">{props.ratingAverages.styleRating}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}
